"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */

var id = 1;

exports.default = function () {
  return "" + id++;
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/size-sensor/lib/id.js
// module id = 701
// module chunks = 0